import '../styles.css';
import { Table, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { useState } from 'react';

import Records from '../record.json';
const BankListOrder = [
  'FAB (First Abu Dhabi Bank)',
  'ADCB (Abu Dhabi Commercial Bank)',
  'RAKBANK',
  'CBD (Commercial Bank of Dubai)',
  'Emirates Islamic Bank',
  'mashreq',
  'Dubai Islamic Bank PJSC',
  'Emirates NBD UAE',
  'scb',
  'Deem_Finance_LLC',
  'hsbcuae',
  'Mawarid Finance',
  'AlHilal Bank',
  'ArabBankUAE',
];
const logoMaster = {
  'FAB (First Abu Dhabi Bank)':
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/fab.png',
  'Dubai Islamic Bank PJSC':
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/dib.png',
  'ADCB (Abu Dhabi Commercial Bank)':
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/adcb.png',
  'CBD (Commercial Bank of Dubai)':
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/cbd.png',
  'Emirates Islamic Bank':
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/EI.png',
  scb: 'https://assets.danubehome.com/media/wysiwyg/EMI/bank/standard.png',
  Deem_Finance_LLC:
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/deem.png',
  hsbcuae: 'https://assets.danubehome.com/media/wysiwyg/EMI/bank/hsbc.png',
  mashreq: 'https://assets.danubehome.com/media/wysiwyg/EMI/bank/mashreq.png',
  RAKBANK: 'https://assets.danubehome.com/media/wysiwyg/EMI/bank/rak.png',
  'Mawarid Finance':
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/mawarid.png',
  'AlHilal Bank':
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/hilal.png',
  ArabBankUAE: 'https://assets.danubehome.com/media/wysiwyg/EMI/bank/arab.png',
  'Emirates NBD UAE':
    'https://assets.danubehome.com/media/wysiwyg/EMI/bank/enbd.png',
};
const processingFeeCorrection = {
  '4BegtmSr': 4900, //enbd 3
  '4ipiqLwC': 4900, //enbd 6
  kgJBaMQK: 2900, //mashreq - 6
  gX9ROYK1: 2900, //mashreq - 9
  VyXovx2g: 2900, //mashreq - 12,
  q2NOFAEP: 4900, //mashreq - 18
  '5nP5s793': 9900, //mashreq - 24
  '10IZJKPZ': 50, // DIB - 0.5%
  vx6Nc29D: 50, //DIB - 0.5%
};

const processingFeeType = {
  '10IZJKPZ': 'Percentage',
  vx6Nc29D: 'Percentage',
};

const InstallmentBanks = () => {
  const [activeTab, setActiveTab] = useState(BankListOrder[0]);

  return (
    <>
      <section className="bankIntrest">
        {/* <div className="container"> */}
        <Nav tabs className="bankLogo">
          {BankListOrder.map((bankname, index) => {
            return Records[0]?.installment_detail?.issuer_detail?.map(
              (bank, i) => {
                if (bank?.issuer_name_en === bankname) {
                  return (
                    <NavItem key={i} className="bankIcon">
                      <NavLink
                        className={
                          activeTab === `${bank?.issuer_name_en}`
                            ? 'active'
                            : ''
                        }
                        onClick={() => setActiveTab(`${bank?.issuer_name_en}`)}
                      >
                        <img
                          src={
                            logoMaster[bank?.issuer_name_en] ||
                            bank?.issuer_logo_en
                          }
                        />
                      </NavLink>
                    </NavItem>
                  );
                }
              }
            );
          })}
        </Nav>
        <TabContent activeTab={activeTab}>
          {(Records[0]?.installment_detail?.issuer_detail).map((issuer, i) => (
            <TabPane tabId={`${issuer.issuer_name_en}`}>
              <div className="bankIntrestTableSec">
                <Table
                  className="bankIntrestTable"
                  cellPadding="10"
                  cellSpacing="0"
                  border="0"
                >
                  <thead>
                    <tr>
                      <th colSpan="3" style={{ textAlign: 'left' }}>
                        {issuer.issuer_name_en}
                      </th>
                    </tr>
                    <tr>
                      <th>Month</th>
                      <th>Interest</th>
                      <th>Process Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(issuer?.plan_details).map((plan_details, inx) => (
                      <>
                        <tr>
                          <td>{plan_details?.number_of_installment}</td>
                          <td>{plan_details?.fee_display_value / 100}%</td>
                          <td>
                            {' '}
                            {(processingFeeType[plan_details?.plan_code] ||
                              plan_details?.processing_fees_type) ===
                            'Fixed' ? (
                              <>
                                {' '}
                                {plan_details?.currency_code}{' '}
                                {(processingFeeCorrection[
                                  plan_details.plan_code
                                ] || plan_details?.processing_fees_amount) /
                                  100}
                              </>
                            ) : (
                              <>
                                {(processingFeeCorrection[
                                  plan_details.plan_code
                                ] || plan_details?.processing_fees_amount) /
                                  100}
                                %
                              </>
                            )}
                          </td>
                        </tr>
                      </>
                    ))}
                    <tr>
                      <td colSpan={4} style={{ textAlign: 'left' }}>
                        {issuer?.processing_fees_message_en}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={4} style={{ textAlign: 'right' }}>
                        <a
                          target="_blank"
                          href={issuer?.terms_and_condition_en}
                        >
                          Subject to Bank's T&C
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                {console.log(issuer?.plan_details?.[0])}
              </div>
            </TabPane>
          ))}
        </TabContent>

        {/* cellPadding="10" cellSpacing="0"  */}

        {/* </div> */}
      </section>
    </>
  );
};
export default InstallmentBanks;
